import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import SixthFlow from 'components/Flows/SixthFlows/SixthFlows';
import SixthAnalysisDrawer from 'components/Analyses/SixthAnalyses/Drawer/Drawer';
import SixthFlowPromptsDrawer from 'components/Flows/SixthFlows/Prompts/Drawer/Drawer';

const SixthFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <SixthAnalysisDrawer />
      <SixthFlowPromptsDrawer />
      <SixthFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SixthFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);